<template>
  <div class="app-container">
    <list ref="list"></list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/craftsmanship/process/list'


export default {
  name: "process",
  mixins: [curdMixins],
  components: {
    list,
  },
  
};
</script>